const NAMES = ['a', 'b', 'select', 'start', 'right', 'left', 'up', 'down'];

export function createInput(state, buttonState, Button) {
  const BUTTONS = {
    z: Button.A,
    Z: Button.A,
    x: Button.B,
    X: Button.B,
    Shift: Button.Select,
    Enter: Button.Start,
    ArrowRight: Button.Right,
    ArrowLeft: Button.Left,
    ArrowUp: Button.Up,
    ArrowDown: Button.Down,
  };
  const activeTouches = new Map();

  function getButtonElement(btn) {
    return document.querySelector(`.gp-btn[data-btn="${btn}"]`);
  }

  function pressButton(btn, fromKeyboard = false) {
    if (!state.emulator || state.paused) return;
    state.emulator.set_button(btn, true);
    buttonState[NAMES[btn]] = true;
    if (fromKeyboard) {
      const el = getButtonElement(btn);
      if (el) el.classList.add('pressed');
    }
  }

  function releaseButton(btn, fromKeyboard = false) {
    if (!state.emulator) return;
    state.emulator.set_button(btn, false);
    buttonState[NAMES[btn]] = false;
    if (fromKeyboard) {
      const el = getButtonElement(btn);
      if (el) el.classList.remove('pressed');
    }
  }

  function onKeyDown(e) {
    if (e.target.tagName === 'INPUT') return;

    if (e.code === 'Space') {
      e.preventDefault();
      state.paused = !state.paused;
      return;
    }
    if (e.key === 'n' || e.key === 'N') {
      if (state.paused && state.emulator) state.stepMode = 'instruction';
      return;
    }
    if (e.key === 'f' && !e.ctrlKey && !e.metaKey) {
      if (state.paused && state.emulator) state.stepMode = 'frame';
      return;
    }

    const btn = BUTTONS[e.key];
    if (btn !== undefined) {
      e.preventDefault();
      pressButton(btn, true);
    }
  }

  function onKeyUp(e) {
    const btn = BUTTONS[e.key];
    if (btn !== undefined) {
      releaseButton(btn, true);
    }
  }

  function onTouchStart(e) {
    const target = e.target.closest('.gp-btn');
    if (!target) return;
    e.preventDefault();

    const btn = parseInt(target.dataset.btn, 10);
    if (isNaN(btn)) return;

    for (const touch of e.changedTouches) {
      activeTouches.set(touch.identifier, { btn, target });
    }
    target.classList.add('pressed');
    pressButton(btn);
  }

  function onTouchEnd(e) {
    for (const touch of e.changedTouches) {
      const info = activeTouches.get(touch.identifier);
      if (info) {
        info.target.classList.remove('pressed');
        releaseButton(info.btn);
        activeTouches.delete(touch.identifier);
      }
    }
  }

  function onTouchCancel(e) {
    onTouchEnd(e);
  }

  function onMouseDown(e) {
    const target = e.target.closest('.gp-btn');
    if (!target) return;
    e.preventDefault();

    const btn = parseInt(target.dataset.btn, 10);
    if (isNaN(btn)) return;

    target.classList.add('pressed');
    pressButton(btn);
    target.dataset.mouseDown = '1';
  }

  function onMouseUp(e) {
    const target = e.target.closest('.gp-btn');
    if (!target || !target.dataset.mouseDown) return;

    const btn = parseInt(target.dataset.btn, 10);
    if (isNaN(btn)) return;

    target.classList.remove('pressed');
    releaseButton(btn);
    delete target.dataset.mouseDown;
  }

  function onMouseLeave(e) {
    const target = e.target.closest('.gp-btn');
    if (!target || !target.dataset.mouseDown) return;

    const btn = parseInt(target.dataset.btn, 10);
    if (!isNaN(btn)) {
      target.classList.remove('pressed');
      releaseButton(btn);
    }
    delete target.dataset.mouseDown;
  }

  return {
    attach() {
      window.addEventListener('keydown', onKeyDown);
      window.addEventListener('keyup', onKeyUp);

      const gamepad = document.getElementById('gamepad');
      if (gamepad) {
        gamepad.addEventListener('touchstart', onTouchStart, { passive: false });
        gamepad.addEventListener('touchend', onTouchEnd);
        gamepad.addEventListener('touchcancel', onTouchCancel);
        gamepad.addEventListener('mousedown', onMouseDown);
        gamepad.addEventListener('mouseup', onMouseUp);
        gamepad.addEventListener('mouseleave', onMouseLeave, true);
      }
    },
  };
}
